$(document).ready(function () {
  $('.parent-menu-item a.submenu-item').click(function(e) {
    e.preventDefault();

    $(this).parents('.parent-menu-item').addClass('open');
    $(this).parents('.menu-drawer__menu').addClass('submenu-open');
  });

  $('.child-menu-item a.submenu-item').click(function(e) {
    e.preventDefault();

    $(this).parents('.child-menu-item').addClass('open');
    $(this).parents('.parent-menu-item').addClass('submenu-open');
  });

  
  $('.backmenu-btn.level-1').click(function (e) {
    e.preventDefault();

    $(this).parents('.parent-menu-item').removeClass('open');
    $(this).parents('.menu-drawer__menu').removeClass('submenu-open');
  });

  $('.backmenu-btn.level-2').click(function (e) {
    e.preventDefault();

    $(this).parents('.child-menu-item').removeClass('open');
    $(this).parents('.parent-menu-item').removeClass('submenu-open');
  });
});